import isBoolean from 'lodash/isBoolean';

export default {
  SET_QUEUE_LIST(state, queueList) {
    state.queueList = queueList;
  },
  REMOVE_QUEUE_ITEM(state, idToRemove) {
    state.queueList = state.queueList.filter(item => item.id !== idToRemove);
  },
  SET_FILTER(state, filter) {
    state.filtered = filter;
  },
  TOGGLE_QUEUE(state, open) {
    state.isQueueOpened = isBoolean(open) ? open : !state.isQueueOpened;
  },
  TOGGLE_ACTION_LOADING(state, loading) {
    state.loadingQueueAction = loading;
  },
};
